// fee-class.js — the ONE shared resolver for an aircraft's pad-fee class.
//
// Pad fees can differ per aircraft MODEL CLASS (HELISTAR: H135 / AS365 / H120 —
// each with its own per-pad landing/departure/handling/special). The class is an
// explicit curated field on the aircraft doc (`feeClass`, options in Site
// Settings, like `type`); when unset it falls back to the weight/engine `type`
// label so nothing breaks pre-migration (a `type` value matches no per-class fee
// row → the flat default applies, identical to before).
//
// Pure + import-only: BOTH the server money-gate (pricing.js / bookings-create /
// quote) AND the client funnel (App.jsx) import this, so the class that drives a
// pad fee is identical on both sides → no client/server price split → no 400.

/**
 * @param {Object|null} aircraftDoc — aircraft doc/projection with { feeClass?, type? }.
 * @returns {string|null} the pad-fee class key, or null when neither is set.
 */
export function feeClassOf(aircraftDoc) {
  if (!aircraftDoc) return null;
  const fc = aircraftDoc.feeClass;
  if (typeof fc === 'string' && fc.trim() !== '') return fc.trim();
  const ty = aircraftDoc.type;
  if (typeof ty === 'string' && ty.trim() !== '') return ty.trim();
  return null;
}
